<div class="bp-modal mod-lg" [class.elevated]="isSecondStep">
  @if (!summary) {
    @if (currentStep; as header) {
      <bp-modal-header
        class="font-semibold"
        [step]="header.step"
        [title]="header.title">
        @if (header.left; as left) {
          <a
            left
            (click)="onHeaderButtonClick(left)"
            (keydown.enter)="onHeaderButtonClick(left)"
            [tabIndex]="0">
            {{ left | translate }}
          </a>
        }
        @if (header.right; as right) {
          <a
            right
            (click)="onHeaderButtonClick(right)"
            (keydown.enter)="onHeaderButtonClick(right)"
            [tabIndex]="0">
            {{ right | translate }}
          </a>
        }
      </bp-modal-header>
    }
    <div class="bp-modal-body">
      <div class="bp-modal-body-section" [ngClass]="{ 'pb-0': isThirdStep }">
        @if (isFirstStep) {
          @if (getNonEmptyWallets()?.length > 0) {
            <tradable-wallet
              [tradableWallets]="availableWallets()"
              [ngClass]="'modal-grid mod-two-cols'"
              (onSelect)="selectSenderWallet($event)"
            (onRefresh)="doTrapFocusTime()"></tradable-wallet>
          }
          @if (getNonEmptyWallets()?.length === 0) {
            <empty
              [headline]="'no_wallet_has_any_funds_headline' | translate"
              text="no_wallet_has_any_funds_text">
            </empty>
          }
        }
        @if (isSecondStep) {
          @if (getWallets()?.length > 0) {
            <div class="bp-modal-description">
              {{ "send_own_chose_other_wallet" | translate }}
            </div>
          }
          <tradable-wallet
            [tradableWallets]="otherWallets()"
            [ngClass]="'modal-grid mod-two-cols'"
            (onSelect)="selectReceiverWallet($event)"
            (onRefresh)="doTrapFocusTime()">
          </tradable-wallet>
        }
        @if (isThirdStep) {
          <div>
            <div class="bp-modal-description">{{ "select_amount" | translate }}</div>
            <div class="modal-grid mod-three-cols">
              @for (amount of getAmounts(); track amount) {
                <tradable-amount-tile
                  [ngClass]="'grid-item'"
                  (click)="setAmount(amount)"
                  [fiat]="getFiat()"
                  (keydown.enter)="setAmount(amount)"
                  [conversion]="amount"
                [tradable]="getItem()"></tradable-amount-tile>
              }
              <tradable-amount-tile
                [ngClass]="'grid-item'"
                (click)="setMaxAmount()"
                [conversion]="maxAmount()"
                [all]="true"
                [fiat]="getFiat()"
                (keydown.enter)="setMaxAmount()"
              [tradable]="getItem()"></tradable-amount-tile>
            </div>
          </div>
        }
      </div>
      @if (isThirdStep) {
        <div class="bp-modal-body-section mod-fullwidth pt-30 pb-0">
          <div class="items-start flex-wrap modal-internal-transfer mod-input">
            <bp-input
              iconLeading="true"
              class="mod-input-line"
              [type]="getInputFormat()"
              [icon]="getIcon()"
              min="0"
              name="amount_fiat"
              [step]="getStepsFromOfferFiat()"
              required
              autofocus
              [(value)]="amount"
              [formGroupClass]="false"
              (onFocus)="inputOnFocus($event)">
              <a right (click)="change('swap')" class="hover-pointer" href="javascript:">
                <span
								[ngClass]="{
									'text-transparent font-size-13': userWants !== 'cryptocoin',
									'text-highlight font-size-17': userWants === 'cryptocoin'
								}">
                  {{ getItem()?.getSymbol() }}
                </span>
                &nbsp;/&nbsp;
                <span
								[ngClass]="{
									'text-transparent font-size-13': userWants !== 'fiat',
									'text-highlight font-size-17': userWants !== 'cryptocoin'
								}">
                  {{ getFiat()?.getSymbol() }}
                </span>
              </a>
            </bp-input>
          </div>
          <!-- labels: min amount + fees info -->
          <div class="bp-modal-row mt-10 bp-modal-custom-margin modal-internal-transfer mod-input">
            <div class="bp-modal-column left"></div>
            <div class="bp-modal-column right text-gray">
              1 {{ getItem()?.getSymbol() }} &asymp;&nbsp;
              {{
              price?.getPrice()?.getFiat()
              | fiat_precision_symbol: { id: getFiat()?.getId(), currencies: [getFiat(), getItem()] }
              }}
            </div>
          </div>
          <hr class="mb-20 mt-30" />
          <div class="pl-50 pr-50">
            <div class="bp-modal-row font-size-24" [ngClass]="{ 'text-light': !getSufficientFunds() }">
              <div class="bp-modal-column left mr-5">{{ "amount_total" | translate }}</div>
              <div class="bp-modal-column right break">
                <strong>
                  {{
                  amountItemTotal()
                  | tradable_precision
                  : { id: getItem()?.getId(), currencies: [getItem()], ignorePrecision: true }
                  }}
                </strong>
                {{ getItem()?.getSymbol() }}
              </div>
            </div>
            <div class="bp-modal-row font-size-15">
              <div class="bp-modal-column left mr-5"></div>
              <div class="bp-modal-column right break">
                &asymp;
                {{
                getMultiplyTradableAmountByFiatPrice()
                | fiat_precision_symbol
                : { id: this.getFiat().getId(), currencies: [this.getFiat()] }
                }}
              </div>
            </div>
          </div>
          <div class="mt-20 text-center">
            <loading-button
              [loading]="loading"
              (onClick)="save()"
              [text]="'save_send_own_button' | translate"
              type="button"
						[styles]="
							!getSufficientFunds()
								? 'btn btn-primary btn-lg btn-summary mod-send disabled'
								: 'btn btn-primary btn-lg btn-summary mod-send'
						"></loading-button>
          </div>
        </div>
      }
    </div>
  }
  @if (summary) {
    <send-summary [data]="data" (onClose)="close()" (edit)="setEdit($event)" (finish)="finish()">
    </send-summary>
  }
</div>
